"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const Card_1 = require("@material-ui/core/Card");
const CardActionArea_1 = require("@material-ui/core/CardActionArea");
const CardContent_1 = require("@material-ui/core/CardContent");
const CardMedia_1 = require("@material-ui/core/CardMedia");
const styles_1 = require("@material-ui/core/styles");
const mediaUtil_1 = require("@pbl/pbl-react-core/lib/utils/mediaUtil");
const classnames_1 = require("classnames");
const react_i18next_1 = require("react-i18next");
const assets_1 = require("../config/assets");
const config_1 = require("../config/config");
const ArcadeCardBanner_1 = require("./ArcadeCardBanner");
const ArcadeCurrency_1 = require("./ArcadeCurrency");
const styles = (theme) => (0, core_1.createStyles)({
    card: {
        borderRadius: 10,
        backgroundColor: theme.palette.primary.dark
    },
    arcadeCardContainer: {
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(1.5)
    },
    arcadeTopPrize: {
        display: 'flex',
        alignItems: 'center'
    },
    media: {
        height: 260,
        display: 'flex',
        position: 'relative',
        backgroundSize: 'contain',
        [theme.breakpoints.down('lg')]: {
            height: 215
        },
        [theme.breakpoints.down('md')]: {
            height: 333
        },
        [theme.breakpoints.down('sm')]: {
            height: 395
        },
        ['@media (max-width:375px)']: {
            height: 330
        },
        ['@media (max-width:320px)']: {
            height: 291
        }
    }
});
const ArcadeCard = ({ game, onPress, classes }) => {
    var _a, _b;
    const onClick = () => {
        onPress(game);
    };
    const baseUri = !!config_1.config.internalConfig.BASE_URL ? config_1.config.internalConfig.BASE_URL : '';
    const imageUrl = !!game.ticketPosImage
        ? (0, mediaUtil_1.createMediaURL)(baseUri, '/media/api/file/', game.ticketPosImage)
        : assets_1.assets.internalAssets.noImage;
    const { t } = (0, react_i18next_1.useTranslation)();
    let priceText = ((_a = game.retailPriceMin) === null || _a === void 0 ? void 0 : _a.toPointsFormat()) || '';
    priceText = game.retailPriceMax
        ? `${priceText} - ${(_b = game.retailPriceMax) === null || _b === void 0 ? void 0 : _b.toPointsFormat()}`
        : priceText;
    return ((0, jsx_runtime_1.jsx)(Card_1.default, Object.assign({ onClick: onClick, className: (0, classnames_1.default)('po-widget-card', classes.card) }, { children: (0, jsx_runtime_1.jsxs)(CardActionArea_1.default, { children: [(0, jsx_runtime_1.jsx)(CardMedia_1.default, Object.assign({ className: classes.media, image: imageUrl }, { children: (0, jsx_runtime_1.jsx)(ArcadeCardBanner_1.default, { prize: priceText }) })), (0, jsx_runtime_1.jsxs)(CardContent_1.default, Object.assign({ className: classes.arcadeCardContainer }, { children: [(0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ color: "secondary", variant: "subtitle1", noWrap: true, component: 'p' }, { children: game.name })), (0, jsx_runtime_1.jsxs)(core_1.Typography, Object.assign({ color: "primary", variant: "body2", className: classes.arcadeTopPrize }, { children: [t('arcade.topPrize', { amount: game.topPrize.toPointsFormat() }), (0, jsx_runtime_1.jsx)(ArcadeCurrency_1.default, { color: 'secondary' })] }))] }))] }) })));
};
exports.default = (0, styles_1.withStyles)(styles)(ArcadeCard);
//# sourceMappingURL=ArcadeCard.js.map